export default {
  components: {
    balanceWidget: {
      balanceRow: 'dt.myAccount.components.balanceWidget.balanceRow',
      balanceAmount: 'dt.myAccount.components.balanceWidget.balanceAmount',
    },
    userDetail: {
      container: 'dt.myAccount.components.userDetail.container',
    },
  },
  topSection: {
    withdrawableBalance: 'dt.myAccount.header.withdrawableBalance',
  },
  transactionHistory: {
    accordion: 'dt.myAccount.transactionHistory.accordion',
    noTransactionsLabel: 'dt.myAccount.transactionHistory.noTransactionsLabel',
    balanceCell: 'dt.myAccount.transactionHistory.balanceCell',
    transactionHistoryModalItem: 'dt.myAccount.transactionHistory.transactionHistoryModalItem',
    recentTransactions: 'dt.myAccount.transactionHistory.recentTransactions',
    pendingTransactions: 'dt.myAccount.transactionHistory.pendingTransactions',
    tableRow: 'dt.myAccount.transactionHistory.tableRow',
    amountCell: 'dt.myAccount.transactionHistory.amountCell',
    accordionButton: 'dt.mymyAccount.transactionHistory.accordionButton',
    tableCell: 'dt.myAccount.transactionHistory.tableCell',
  },
};
